import React, { useRef, useEffect, useState } from 'react';
import heart_path from 'heart_path.svg';
import ReactSVG from 'react-svg';
import axios from 'axios';
import ReactGA from 'react-ga';
import { toast } from 'react-toastify';
import { disableBodyScroll } from 'body-scroll-lock';
import default_listing_image from 'default_listing_image.svg';
import Ratings from '../Ratings';
import { handleHeartAnimation } from '../../utils/handleHeartAnimation';
import FavoriteSuccessBanner from '../CustomToast/FavoriteSuccessBanner';

export default function MobileListingActiveMarker({ item, userData }) {
  // console.log(item);
  const heartRef = useRef(null);

  const displayImage =
    item.small_featured_image_url ||
    item.medium_featured_image_url ||
    default_listing_image;

  const [favorited, setFavorited] = useState(false);
  useEffect(() => {
    if (item.favorited) {
      setFavorited(true);
    }
  }, [item]);

  const [favoriteRoute, setFavoriteRoute] = useState(null);
  useEffect(() => {
    setFavoriteRoute(window.Routes.favorite_listing_path({ id: item.slug }));
  }, [item]);

  const handleFavorited = () => {
    const tokenElement = document.querySelector('[name=csrf-token]');
    if (userData && userData.user && userData.user.id) {
      handleHeartAnimation({ ref: heartRef, isFavorited: favorited });
      axios
        .patch(favoriteRoute, null, {
          headers: {
            'X-CSRF-Token': tokenElement ? tokenElement.content : '',
            Accept: 'application/json',
          },
        })
        .then(res => {
          if (res.status === 200) {
            toast.dismiss();
            if (!favorited)
              toast(<FavoriteSuccessBanner favorited type={item} />);
            else toast(<FavoriteSuccessBanner type={item} />);
            setFavorited(!favorited);
          }
        })
        .catch(err => {
          console.error(err);
          if (err.response.status === 401) {
            window.location.pathname = window.Routes.login_path();
          }
        });
    } else {
      const modal = document.querySelector('#popup-modal');
      modal.classList.remove('fadeOut');
      modal.classList.remove('hidden');
      modal.classList.add('fadeIn');
      disableBodyScroll(modal);
    }
  };

  return (
    <div className="mobile-rental-active-marker">
      <button
        aria-label="Toggle Favorite"
        name="Toggle Favorite"
        ref={heartRef}
        type="button"
        className={`card-heart ${item.favorited ? 'favorited' : ''}`}
        onClick={handleFavorited}
      >
        <ReactSVG src={heart_path} className="heart-icon" />
      </button>

      <a
        href={window.Routes.listing_type_show_path({
          area: item.city_name || '30a',
          is_type: item.is_type,
          category: item.category ? item.category.slug : 'fake',
          url: item.slug,
        })}
        onClick={() => {
          if (window.location.pathname === '/search') {
            ReactGA.event({
              category: 'Listing',
              action: 'Viewed Listing from Search',
            });
          }
        }}
      >
        <section className="image-section-wrapper">
          <img
            src={displayImage}
            alt={`${item.name}`}
            aria-label={`${item.name}`}
          />
          <div className="image-overlay" />
          <Ratings
            rating={item.rating}
            rating_count={item.rating_count}
            secondaryColor
          />
        </section>

        <section className="info-section-wrapper listing">
          <div className="listing-category">
            <img src={item.category_image_url} alt="" className="item-logo" />
            <h4 className="item-type">{item.category.name}</h4>
          </div>

          <div>
            <h3 className="item-name">{item.title}</h3>
            <ul className="item-details">
              <li className="listing-city">{item.city_name}</li>
            </ul>
          </div>
        </section>
      </a>
    </div>
  );
}
